import React from 'react';

import { ErrorBoundry } from '../components/errorCatchall';

import { GameInfo } from '../components/gameInfo';
import { Island } from '../components/island';
import { Restore } from '../components/restore';


import Player from '../functions/player';

export class Game extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      partOfGame: 3,
      timerOver: false,
      currentRound: 1,
      islandImage: `url(` + require("../assets/elements/Island0.svg") + `)`,
      updateSlidersNo: 0,
    }
  }

  handleGreenCallback = (val) => {
    let image;

    if(val <= 25){
      image = `url(` + require("../assets/elements/Island0.svg") + `)`;
    } else if(val > 25 && val <= 50) {
      image = `url(` + require("../assets/elements/Island25.svg") + `)`;
    } else if(val > 50 && val <= 75) {
      image = `url(` + require("../assets/elements/Island50.svg") + `)`;
    } else if(val > 75) {
      image = `url(` + require("../assets/elements/Island75.svg") + `)`;
    }

    this.setState({
      islandImage: image,
      updateSlidersNo: this.state.updateSlidersNo + 1,
    })
  }

  componentWillMount(){
    var currentLocation = this.props.location.pathname;
    Player.storeData('localRoute', currentLocation);

    const currentPart = Player.getData('partOfGame');
    this.setState({
      partOfGame: currentPart,
    });
  }

  componentDidMount(){

    this.setState({
      currentRound: Player.getData("round"),
    });

    window.addEventListener("load", this.maintainRatio);
    window.addEventListener("resize", this.maintainRatio);
    this.maintainRatio();
  }

  maintainRatio = () => {
    const aspectWidth = 4;
    const aspectHeight = 3;

    const element = document.getElementById("maintainRatio");
    if(element !== null){
      const width = element.clientWidth;

      const screenWidth = Math.max(window.innerWidth, 1024);
      const screenHeight = Math.max(window.innerHeight, 768);

      let newWidth = screenWidth;
      let newHeight = (width / aspectWidth) * aspectHeight;

      if(newHeight > screenHeight){
        newHeight = screenHeight;
        newWidth = (newHeight / aspectHeight) * aspectWidth;
      }

      element.style.width = newWidth + "px";
      element.style.height = newHeight + "px";


      const scoreView = document.getElementsByClassName("gameInfo game")[0];
      if(scoreView !== undefined){
        scoreView.style.width = (newWidth / 3) + "px";
        scoreView.style.height = (newHeight * 0.226) + "px";
      }
    }

  }

  render() {
    return(
      <ErrorBoundry>
        <div className="boardWrap">
          <Restore />
          <div className="full-page-background"></div>
          <div className="gameBoard">
            <GameInfo updateSliders={this.state.updateSlidersNo} roundChangeCallBack={this.handleCallback} part={this.state.partOfGame} game="true" time={this.state.time} getGameScreen={() => {return this.props.location.pathname}} />
            <img alt='Cloud' className="cloud-1" src={require("../assets/elements/Cloud.svg")}/>
            <img alt='Cloud' className="cloud-2" src={require("../assets/elements/Cloud.svg")}/>
            <img alt='Cloud' className="cloud-3" src={require("../assets/elements/Cloud.svg")}/>
            <img alt='Cloud' className="cloud-4" src={require("../assets/elements/Cloud.svg")}/>
            <img alt='Cloud' className="cloud-5" src={require("../assets/elements/Cloud.svg")}/>
            <img alt='Cloud' className="cloud-6" src={require("../assets/elements/Cloud.svg")}/>
            <img alt='Cloud' className="cloud-7" src={require("../assets/elements/Cloud.svg")}/>
            <img alt='Cloud' className="cloud-8" src={require("../assets/elements/Cloud.svg")}/>
            <div id="maintainRatio" style={{backgroundImage: this.state.islandImage}}className="content">
              <Island ref='board' round={this.state.currentRound} percentageGreen={this.handleGreenCallback}/>
            </div>
          </div>
        </div>
      </ErrorBoundry>
    )
  }

}



// WEBPACK FOOTER //
// ./src/pages/game.js